export enum FileType {
  Image,
  ImageBasic,
  Pdf,
  Unknown,
}
